import ModalSignup from './ModalSignup';

export default ModalSignup;

export { type Props } from './ModalSignup';
